import './assets/css/App.css';
import {Navigate, Route, Routes} from 'react-router-dom';
import {ChakraProvider,} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import {useState} from 'react';
import SignInPage from "./pages/SignInPage";
import PatientDetailsPage from "./pages/PatientDetailsPage.tsx";
import UrlPhotoView from "./components/patientComponent/UrlPhotoView.tsx";
import MainDashboard from "./mainDashboard/MainDashboard.tsx";
import DashboardContent from "./components/dashboardComponents/DashboardContent.tsx";
import PatientList from "./dashboardPages/PatientList.js";
import UserList from "./dashboardPages/UserList.js";
import NotFoundPage from "./pages/NotFoundPage.tsx";
import ProtectedRoute from "./protectedRoutes/ProtectedRoutes.tsx";

export default function Main() {
    // eslint-disable-next-line
    const [currentTheme, setCurrentTheme] = useState(initialTheme);
    return (
        <ChakraProvider theme={currentTheme}>
            <Routes>
                <Route path="/signin"
                       element={<ProtectedRoute isProtected={false} redirectIfAuthenticated element={<SignInPage/>}/>}/>
                <Route
                    path="/patients/:id"
                    element={<ProtectedRoute element={<PatientDetailsPage/>}/>}
                />
                <Route
                    path="/urlPhotoView"
                    element={<ProtectedRoute element={<UrlPhotoView/>}/>}
                />

                <Route
                    path="/admin"
                    element={<ProtectedRoute
                        element={<MainDashboard theme={currentTheme} setTheme={setCurrentTheme}/>}/>}
                >
                    <Route path="dashboard" element={<DashboardContent/>}/>
                    <Route path="patients" element={<PatientList/>}/>
                    <Route
                        path="doctors"
                        element={<ProtectedRoute requireSuperuser element={<UserList/>}/>}
                    />
                    <Route index element={<Navigate to="/admin/dashboard"/>}/>
                </Route>

                <Route path="/" element={<Navigate to="/admin/dashboard" replace/>}/>

                {/*    /!* 👇 Catch-all Not Found route *!/*/}
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </ChakraProvider>
    );
}
